import { motion } from "framer-motion";

export default function Footer() {
  return (
    <footer className="footer">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="footer-content"
      >
        <div className="footer-section branding">
          <h2 className="footer-logo">Ojo Azeez Olawale</h2>
          <p>Building digital experiences that matter.</p>
          <div className="social-links">
            <a href="https://github.com/Oluwamighty" target="_blank" rel="noopener noreferrer">GitHub</a>
            <a href="https://linkedin.com/in/azeezojo" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            <a href="https://web.facebook.com/olawale.ojo.5623/" target="_blank" rel="noopener noreferrer">Facebook</a>
          </div>
        </div>

        <div className="footer-section links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#projects">Projects</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-section contact-info">
          <h3>Get In Touch</h3>
          <p>Email: olawaleojo42@email.com</p>
          <p>Location: Lagos, Nigeria</p>
          <p>Tel: 08105978632</p>
        </div>
      </motion.div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Ojo Azeez Olawale | All Rights Reserved</p>
      </div>
    </footer>
  );
}

